export default "__VITE_ASSET__B236ijpF__"